import FormRange from './FormRange.vue';
export default FormRange;



// WEBPACK FOOTER //
// ./src/components/form/formrange/index.ts